export default "__VITE_ASSET__C$LrOjiS__"